const styles = () => ({
  label: {
    marginBottom: '6px',
    display: 'block',
    fontSize: '16px'
  }
})

export default styles
